import { FieldValues, Path, UseFormRegister } from "react-hook-form";
import { lang } from "../../assets/languages/en.language";
import { formConfig } from "../../configs/form.config";
import { FormLabel, StyledInput, StyledInputWrapper } from "../../styles/Form";
import { Gap } from "../../styles/Utils";

interface DogNameInputProps<T extends FieldValues> {
  register: UseFormRegister<T>; // Register function from RHF
  name: Path<T>; // The field name should be a key from the form data type
  disabled?: boolean;
}

export default function DogNameInput<T extends FieldValues>({ register, name, disabled }: DogNameInputProps<T>) {
  return (
    <StyledInputWrapper>
      <FormLabel>{lang?.landingPage.form.dogName.label}</FormLabel>
      <Gap $height={0.5} />
      <StyledInput
        {...register(name, {
          required: true,
          pattern: {
            value: formConfig.dogName.pattern,
            message: lang.inputs.dogNamePattern,
          },
        })}
        placeholder={lang.landingPage.form.dogName.placeholder}
        disabled={disabled}
      />
    </StyledInputWrapper>
  );
}
